import { DatePipe } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { IRecentActivityItem, RecentActivityCategory } from 'core/types/recent-activity.interface';
import { isAcceptedReferralActivity } from 'shared/utils/recent-activity.utils';

@Component({
  selector: 'app-recent-activity',
  imports: [DatePipe],
  templateUrl: './recent-activity.component.html',
  styleUrl: './recent-activity.component.scss'
})
export class RecentActivityComponent {
  readonly items = input.required<readonly IRecentActivityItem[]>();
  readonly activityClick = output<IRecentActivityItem>();

  readonly rows = computed(() => this.items().map(item => ({ item, disabled: isAcceptedReferralActivity(item) })));

  readonly iconByCategory: Readonly<Record<IRecentActivityItem['category'], string>> = {
    [RecentActivityCategory.DEPOSITS]: 'assets/img/recent-activity/deposits.svg',
    [RecentActivityCategory.REDEMPTIONS]: 'assets/img/recent-activity/redemptions.svg',
    [RecentActivityCategory.REFERRALS]: 'assets/img/recent-activity/referrals.svg',
    [RecentActivityCategory.SPROUTS]: 'assets/img/recent-activity/sprouts.svg',
    [RecentActivityCategory.PROMOTIONS]: 'assets/img/recent-activity/promotions.svg',
    [RecentActivityCategory.MISSIONS]: 'assets/img/recent-activity/missions.svg',
    account: 'assets/img/recent-activity/deposits.svg'
  };
  readonly chevronIcon = 'assets/img/recent-activity/chevron-right.svg';

  public onActivityClick(item: IRecentActivityItem): void {
    if (!isAcceptedReferralActivity(item)) {
      this.activityClick.emit(item);
    }
  }
}
